import {searchModel} from "../../../../Utilities/Search";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {dynamicSort} from "../../../../Utilities/Sort";

export const braillerCatalogSearchModel = (userId = "", searchTerm = "", catalogNumber = "", isActive = true) => {
    return Object.assign({}, searchModel(userId.toString(), "title", false, "title"), {
        searchTerm: searchTerm,
        catalogNumber: catalogNumber,
        isActive: isActive,
        ClearCatalogSearch: clearCatalogSearch,
        ApplySorting: applySorting,
    });
};

function clearCatalogSearch(this: Record<string, unknown>) {
    this.searchTerm = "";
    this.catalogNumber = "";
    this.isActive = true;
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function applySorting(braillerCatalogSearchCriteria: Record<string, unknown>, items: Record<string, unknown>[]) {
    if (isNullOrUndefined(items) || isArrayNullOrEmpty(items))
        return items;

    return items.sort(dynamicSort(braillerCatalogSearchCriteria.sortByColumn as string, braillerCatalogSearchCriteria.sortDescending as boolean));
}